// tslint:disable
/**
 * respondeco.org
 * API description of respondeco.org
 *
 * The version of the OpenAPI document: 1.2.5
 * Contact: klaus@respondeco.org
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
  import {
    LookupItem,
    LookupItemFromJSON,
    LookupItemToJSON,
  } from '../models';

      export interface LookupOrganisationsRequest {
        query?: string;
      }


/**
* no description
*/
export interface LookupApi {
    /**
      * List of all available categories
    */
    getCategories(): Promise<Array<LookupItem>>
    /**
      * List of all available offer types
    */
    getOfferTypes(): Promise<Array<LookupItem>>
    /**
      * List of available organisation sectors
    */
    getOrganisationSectors(): Promise<Array<LookupItem>>
    /**
      * List of available organisation types
    */
    getOrganisationTypes(): Promise<Array<LookupItem>>
    /**
      * Returns a list of organisations (just the id and the name) that can be filtered by name
    */
    lookupOrganisations(requestParameters: LookupOrganisationsRequest): Promise<Array<LookupItem>>
}

  /**
  * no description
  */
  export class LookupApiImpl extends runtime.BaseAPI implements LookupApi {

    /**
      * List of all available categories
    */
    async getCategoriesRaw(): Promise<runtime.ApiResponse<Array<LookupItem>>> {
      const queryParameters: runtime.HTTPQuery = {};

      const headerParameters: runtime.HTTPHeaders = {};

      const response = await this.request({
      path: `/lookup/categories`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      });

              return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LookupItemFromJSON));
      }

      /**
        * List of all available categories
      */
      async getCategories(): Promise<Array<LookupItem>> {
        const response = await this.getCategoriesRaw();
        return await response.value();
      }

    /**
      * List of all available offer types
    */
    async getOfferTypesRaw(): Promise<runtime.ApiResponse<Array<LookupItem>>> {
      const queryParameters: runtime.HTTPQuery = {};

      const headerParameters: runtime.HTTPHeaders = {};

      const response = await this.request({
      path: `/lookup/offer-types`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      });

              return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LookupItemFromJSON));
      }

      /**
        * List of all available offer types
      */
      async getOfferTypes(): Promise<Array<LookupItem>> {
        const response = await this.getOfferTypesRaw();
        return await response.value();
      }

    /**
      * List of available organisation sectors
    */
    async getOrganisationSectorsRaw(): Promise<runtime.ApiResponse<Array<LookupItem>>> {
      const queryParameters: runtime.HTTPQuery = {};

      const headerParameters: runtime.HTTPHeaders = {};

      const response = await this.request({
      path: `/lookup/organisation-sectors`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      });

              return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LookupItemFromJSON));
      }

      /**
        * List of available organisation sectors
      */
      async getOrganisationSectors(): Promise<Array<LookupItem>> {
        const response = await this.getOrganisationSectorsRaw();
        return await response.value();
      }

    /**
      * List of available organisation types
    */
    async getOrganisationTypesRaw(): Promise<runtime.ApiResponse<Array<LookupItem>>> {
      const queryParameters: runtime.HTTPQuery = {};

      const headerParameters: runtime.HTTPHeaders = {};

      const response = await this.request({
      path: `/lookup/organisation-types`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      });

              return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LookupItemFromJSON));
      }

      /**
        * List of available organisation types
      */
      async getOrganisationTypes(): Promise<Array<LookupItem>> {
        const response = await this.getOrganisationTypesRaw();
        return await response.value();
      }

    /**
      * Returns a list of organisations (just the id and the name) that can be filtered by name
    */
    async lookupOrganisationsRaw(requestParameters: LookupOrganisationsRequest): Promise<runtime.ApiResponse<Array<LookupItem>>> {
      const queryParameters: runtime.HTTPQuery = {};

          if (requestParameters.query !== undefined) {
              queryParameters['query'] = requestParameters.query;
          }

      const headerParameters: runtime.HTTPHeaders = {};

      const response = await this.request({
      path: `/lookup/organisations`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      });

              return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LookupItemFromJSON));
      }

      /**
        * Returns a list of organisations (just the id and the name) that can be filtered by name
      */
      async lookupOrganisations(requestParameters: LookupOrganisationsRequest): Promise<Array<LookupItem>> {
        const response = await this.lookupOrganisationsRaw(requestParameters);
        return await response.value();
      }

    }
